import { Component, OnInit } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { TableMode } from 'src/app/components/grid/grid.component';
import { TableParams } from 'src/app/components/grid/TableParams';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { ICandidate, IExam, IFileDownload } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-examination-candidates',
  templateUrl: './examination-candidates.component.html',
  styleUrls: ['./examination-candidates.component.scss']
})
export class ExaminationCandidatesComponent implements OnInit {
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Candidate Number',
      fieldName: 'examNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Last Name',
      fieldName: 'lastName',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'First Name',
      fieldName: 'firstName',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Other Name',
      fieldName: 'otherNames',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Gender',
      fieldName: 'gender',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Email Address',
      fieldName: 'emailAddress',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Mobile Number',
      fieldName: 'mobileNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Requires Screen Reader',
      fieldName: 'requiresScreenReader',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true
    },
    {
      displayName: 'Skip AI Face Matching',
      fieldName: 'requiresScreenReader',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true
    },
    {
      displayName: 'Unlock Passport Photo',
      fieldName: 'unlockPassportPhoto',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true
    },
    {
      displayName: 'Test Candidate',
      fieldName: 'testCandidate',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true
    },
    {
      displayName: 'Extra Field 1',
      fieldName: 'extraField1',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Extra Field 2',
      fieldName: 'extraField2',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Extra Field 3',
      fieldName: 'extraField3',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }
  ];
  gridName = 'examinationCandidatesGrid';
  selectedCandidates: ICandidate[] = [];
  constructor(private candidateService: CandidateService, private router: Router,
    private serializer: UrlSerializer, private snackBar: SnackbarService, private eventService: EventService) { }

  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));

    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    }); // Ensure the grid is updated after the data is set
  }

  async ngOnInit() {
    this.setCandidate([])
    await this.refreshData(this.data.tableParams);
  }
  setCandidate(canidates: any[]) {
    this.selectedCandidates = canidates;
    this.candidateService.setSelectedCandidate([...this.selectedCandidates]);
  }

  setCandidateData(candidateIds: any[]) {
    if (!this.data?.tableRows.length) { //Just in case tableRows might still not be ready
      setTimeout(() => this.setCandidateData(candidateIds), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedCandidates: any[] = candidateIds.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedCandidates.map(x => x.id);

    GridUtil.setRowCliclk(this.gridName, candidateIds, selectedDataRowsId);
    this.setCandidate(selectedCandidates);
  }

  addCandidateClicked() {
    this.candidateService.setSelectedCandidate([]);
    this.router.navigate(['candidates/view'], {
      queryParams: { mode: 'add' }
    });
  }

  editCandidateClicked() {
    this.router.navigate(['candidates/view'], {
      queryParams: { mode: 'edit' }
    });
  }

  deleteCandidateClicked() {
    let data = { candidateIds: this.candidateService.selectedCandidateIds };
    const reportTree = this.router.createUrlTree([], { queryParams: data });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    this.candidateService.deleteCandidate(params).then(async () => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success("Candidate deleted successfully");
    });
  }

  async exportCandidateClicked() {
    const res = await this.candidateService.getCandidatesExport(this.data.tableParams).then((res: IFileDownload) => {

      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '' + 'data:application/octet-stream;base64,' + res.file);
      link.setAttribute('download', res.fileName + '.' + res.extension);
      document.body.appendChild(link);
      link.click();
      this.snackBar.success("Candidates Exported successfully");
      link.remove();
    });

  }
  async refreshData(tableParams) {
    const res = await this.candidateService.getCandidates(tableParams) as any[];
    this.updateGridParams(res);
  }
  copyCandidateClicked() {
    this.router.navigate(['candidates/view'], {
      queryParams: { mode: 'copy' }
    });
  }
}
